import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const CityField = () => {
    const value = useBrokerDetailsStore((s) => s.homeAddress.city);
    const updateHomeAddress = useBrokerDetailsStore((s) => s.updateHomeAddress);
    const isBroker = useBrokerDetailsStore((s) => s.isBroker);
    const changed = useBrokerFieldFieldChanged(FormField.HomeCity);
    return (
        <>
            <TextBox
                id='hCity'
                value={value}
                onChange={(v) => updateHomeAddress({ city: v })}
                label='City'
                width={'100%'}
                required={isBroker}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
